import * as React from "react";
import { styled } from "@mui/system";
import {
  MAX_WIDTH,
  DISPLAY_FLEX,
  FLEX_DIRECTION_COLUMN,
  FLEX_ALIGN_CENTER,
  POSITION_ABSOLUTE,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_END,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  TEXT_DECORATION_NONE,
  POSITION_RELATIVE,
  FLEX_WRAP_WRAP,
  TEXT_ALIGN_CENTER,
  FONT_WEIGHT_BOLD,
  FONT_SIZE_XXL,
  FONT_WEIGHT_NORMAL,
  USER_SELECT_NONE,
  DISPLAY_INLINE_FLEX,
  BACKGROUND_REPEAT_NO_REPEAT,
  BACKGROUND_SIZE_COVER,
  BACKGROUND_SIZE_CONTAIN,
  FLEX_JUSTIFY_CENTER,
} from "../../config/styles";
 
export const HomePageStyled = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  width: '100vw',
  display: DISPLAY_FLEX,
  justifyContent: FLEX_JUSTIFY_CENTER,
  "& .home-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_CENTER,
    backgroundColor: theme.palette.background.default,
    width: '1200px',
    alignSelf: 'center',
  },
  "& .home-header": {
    padding: "0 5rem",
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    width: MAX_WIDTH,
    height: "80px",
    backgroundColor: theme.palette.background.default,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  },
  "& .header-logo": {
    position: POSITION_ABSOLUTE,
    width: "300px",
    height: "70px",
    top: "18px",
  },
  "& .flex-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_END,
  },
  "& .no-decoration": {
    textDecoration: TEXT_DECORATION_NONE,
    color: "inherit",
  },
  "& .home-body": {
    position: POSITION_RELATIVE,
    backgroundcolor: theme.palette.background.default,
    minWidth: MAX_WIDTH,
  },
  "& .home-body-text": {
    position: POSITION_RELATIVE,
    padding: "1rem",
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    width: MAX_WIDTH,
    alignItems: FLEX_ALIGN_CENTER,
    gap: ".75rem",
    userSelect: USER_SELECT_NONE,
  },
  "& .home-tile-wrapper": {
    padding: "3rem",
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    width: MAX_WIDTH,
    alignItems: FLEX_ALIGN_CENTER,
    position: POSITION_RELATIVE,
    gap: '3rem',
    flexWrap: FLEX_WRAP_WRAP,
  },
  "& .home-tile-item": {
    flex: "45%",
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_CENTER,
    minWidth: "400px",
    padding: "34px 44px 40px 44px",
    gap: "12px",
    borderRadius: "40px",
    backgroundColor: theme.palette.background.paper,
    cursor: "pointer",
    textDecoration: TEXT_DECORATION_NONE,
  },
  "& .home-tile-item:hover": {
    backgroundColor: theme.palette.primary.main,
  },
  "& .home-tile-item-disabled": {
    flex: "45%",
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_CENTER,
    minWidth: "400px",
    padding: "34px 44px 40px 44px",
    gap: "12px",
    borderRadius: "40px",
    backgroundColor: theme.palette.background.paper,
    textDecoration: TEXT_DECORATION_NONE,
    opacity: 0.5,
    userSelect: USER_SELECT_NONE,
    pointerEvents: USER_SELECT_NONE,
  },
  "& .home-tile-header": {
    color: theme.palette.text.primary,
    textAlign: TEXT_ALIGN_CENTER,
    fontFamily: "DM Sans, sans-serif",
    fontWeight: FONT_WEIGHT_BOLD,
    fontSize: '32px',
    lineHeight: "32px",
    letterSpacing: "-0.24px",
    minHeight: "64px",
    display: DISPLAY_FLEX,
    alignItems: FLEX_ALIGN_CENTER,
  },
  "& .home-tile-item:hover .home-tile-header": {
    color: theme.palette.text.primary_hover,
  },
 
  "& .home-tile-body": {
    color: theme.palette.text.secondary,
    textAlign: TEXT_ALIGN_CENTER,
    fontFamily: "DM Sans, sans-serif",
    fontSize: FONT_SIZE_XXL,
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: "33px",
    minHeight: "48px",
  },
  "& .home-tile-item:hover .home-tile-body": {
    color: theme.palette.text.secondary_hover,
  },
  "& .have-questions": {
    position: POSITION_RELATIVE,
    width: MAX_WIDTH,
    padding: "5rem 5rem 0px 5rem",
  },
  " & .home-footer-container": {
    position: POSITION_RELATIVE,
    display: DISPLAY_FLEX,
    width: MAX_WIDTH,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "5rem 5rem 25px 5rem",
    alignItems: FLEX_ALIGN_CENTER,
  },
  "& .home-footer": {
    display: DISPLAY_INLINE_FLEX,
    alignItems: FLEX_ALIGN_CENTER,
    gap: "2rem",
  },
  "& .home-footer-social": {
    display: DISPLAY_INLINE_FLEX,
    alignItems: FLEX_ALIGN_CENTER,
    gap: ".75rem",
  },
  "& .home-footer-bottom": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_CENTER,
    width: MAX_WIDTH,
    marginBottom: "4rem",
  },
  "& .home-tile-image": {
    position: POSITION_RELATIVE,
    backgroundRepeat: BACKGROUND_REPEAT_NO_REPEAT,
    backgroundSize: BACKGROUND_SIZE_COVER,
    objectFit: BACKGROUND_SIZE_CONTAIN,
    padding: "10px 10px 9.999px 10px",
  },
}));